// src/utils/itemUtils.js
export const isBlankDate = (dateString) => {
  return !dateString || dateString === '' || dateString === '0000-00-00';
};

export const isToday = (dateString) => {
  if (isBlankDate(dateString)) return false;
  
  try {
    const itemDate = new Date(dateString + 'T12:00:00');
    const today = new Date();
    
    return today.getFullYear() === itemDate.getFullYear() &&
           today.getMonth() === itemDate.getMonth() &&
           today.getDate() === itemDate.getDate();
  } catch (error) {
    return false;
  }
};

// Un item está EN LISTA si:
// - list_id está asignado Y
//   - status = 0 (uncheck) -> está en lista (la fecha no importa, se conserva
//     como histórico de "última vez comprado"), O
//   - status = 1 (check)   -> está en lista solo si date = hoy
//     (si fue checado en un día anterior, ya no está en lista, pasa a catálogo)
export const isItemInList = (item) => {
  const listId = item.list_id;
  if (listId === null || listId === undefined || listId === '') return false;

  const status = parseInt(item.status) === 1 ? 1 : 0;
  if (status === 0) return true;

  return isToday(item.date);
};

// Cuenta para dropdown: no checados visibles en lista (misma lógica que ListView).
export const isUncheckedListItem = (item) => {
  if (parseInt(item.status) === 1) return false;
  if (parseInt(item.later) === 1) return false;
  return isItemInList(item);
};

export const getListsWithUncheckedCounts = (lists, allItems) => {
  if (!lists?.length) return lists || [];

  return lists.map(list => ({
    ...list,
    item_count: allItems.filter(
      item => isUncheckedListItem(item) && item.list_id === list.id
    ).length
  }));
};

export const hasNote = (item) => {
  return item.note && item.note.trim() !== '';
};

export const formatCategory = (category) => {
  if (!category) return '';
  return category.charAt(0).toUpperCase() + category.slice(1).toLowerCase();
};

export const getTodayDateString = () => {
  const today = new Date();
  return today.getFullYear() + '-' + 
         String(today.getMonth() + 1).padStart(2, '0') + '-' + 
         String(today.getDate()).padStart(2, '0');
};

export const getYesterdayDateString = () => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday.getFullYear() + '-' + 
         String(yesterday.getMonth() + 1).padStart(2, '0') + '-' + 
         String(yesterday.getDate()).padStart(2, '0');
};

export const transformItemData = (item) => ({
  ...item,
  quantity: parseInt(item.quantity) || 0,
  note: item.note || '',
  status: item.status || "0",
  price: item.price || "0",
  date: item.date || "",
  list_id: item.list_id !== undefined && item.list_id !== null && item.list_id !== ''
    ? parseInt(item.list_id)
    : null,
  list_name: item.list_name || '',
  later: parseInt(item.later) === 1 ? 1 : 0
});

// CORREGIDO: getDaysSinceLastUsed usando UTC para evitar problemas de zona horaria
export const getDaysSinceLastUsed = (dateString) => {
  if (!dateString || dateString === '' || dateString === '0000-00-00') return null;
  
  try {
    // Parsear la fecha del item (YYYY-MM-DD) en UTC
    const [year, month, day] = dateString.split('-').map(Number);
    const itemDate = new Date(Date.UTC(year, month - 1, day));
    
    // Fecha de hoy en UTC (medianoche)
    const today = new Date();
    const todayUTC = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
    
    // Calcular diferencia en días
    const diffTime = todayUTC - itemDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    return diffDays;
  } catch (error) {
    console.error('Error calculating days since last used:', error);
    return null;
  }
};

// getDaysText ya está correcto (today, yesterday, X days ago)
export const getDaysText = (days) => {
  if (days === null || days === undefined) return '';
  if (days === 0) return 'today';
  if (days === 1) return 'yesterday';
  return `${days} days ago`;
};

// NUEVAS FUNCIONES AGREGADAS
export const formatPrice = (price) => {
  const numPrice = parseFloat(price) || 0;
  return numPrice.toFixed(2);
};

export const calculateItemTotal = (item) => {
  const price = parseFloat(item.price) || 0;
  const quantity = parseInt(item.quantity) || 0;
  return price * quantity;
};

export const validatePrice = (price) => {
  const numPrice = parseFloat(price);
  return !isNaN(numPrice) && numPrice >= 0;
};

export const formatTaxRate = (taxRate) => {
  const numTaxRate = parseFloat(taxRate) || 0;
  return `${numTaxRate.toFixed(2)}%`;
};

export const calculateListTotal = (items) => {
  return items.reduce((total, item) => {
    if (isItemInList(item)) {
      return total + calculateItemTotal(item);
    }
    return total;
  }, 0);
};

export const calculateCheckedTotal = (items) => {
  return items.reduce((total, item) => {
    if (isItemInList(item) && parseInt(item.status) === 1) {
      return total + calculateItemTotal(item);
    }
    return total;
  }, 0);
};

export const calculateTaxes = (amount, taxRate = 6.5) => {
  return (amount * taxRate) / 100;
};